import React from 'react';
import JobCard from './JobCard';
import './JobList.css';

// Define Job interface for type safety
interface Job {
  id: string;
  title: string;
  company: string;
  location: string;
  salary: number;
  employmentType: string;
  remote: boolean;
  coordinates: [number, number];
  industry: string;
  country: string;
}

interface JobListProps {
  jobs: Job[];
  darkMode: boolean;
  selectedLocation?: {
    city: string;
    country: string;
    costOfLiving: number;
    averageSalary: number;
  } | null;
  onJobClick?: (job: Job) => void;
}

const JobList: React.FC<JobListProps> = ({ jobs, darkMode, selectedLocation, onJobClick }) => {
  
  return (
    <div className="job-list-container">
      <h3>Jobs Found ({jobs.length})</h3>
      
      {jobs.length === 0 ? (
        <div className="no-results">No jobs match your filters</div>
      ) : (
        <div className="job-list">
          {jobs.map(job => (
            <JobCard 
              key={job.id} 
              job={job} 
              onClick={onJobClick}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default JobList;